var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { logger } from "../helpers";
var identity = new Map([["hide_default_launcher", true]]);
var IntercomProvider = {
    identity: {
        set: function (key, value) {
            identity.set(key, value);
        },
        remove: function (key) {
            identity.delete(key);
        },
        clear: function () {
            identity.clear();
        },
    },
    init: function (language) {
        var e_1, _a;
        if (language === void 0) { language = "cs"; }
        logger.log("IntercomProvider", window.Intercom ? "Check OK" : "window.Intercom is missing");
        var data = {};
        try {
            for (var _b = __values(identity.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), key = _d[0], value = _d[1];
                data[key] = value;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        data["language_override"] = language;
        logger.log("IntercomProvider", "Boot", data);
        if (window.Intercom) {
            return window.Intercom("boot", data);
        }
    },
    show: function () {
        logger.log("IntercomProvider", "Open");
        if (window.Intercom) {
            return window.Intercom("show");
        }
        logger.log("show intercom");
    },
    hide: function () {
        logger.log("IntercomProvider", "Hide");
        if (window.Intercom) {
            return window.Intercom("hide");
        }
        logger.log("hide intercom");
    },
    restart: function () {
        this.shutdown();
        this.init();
    },
    shutdown: function () {
        logger.log("IntercomProvider", "Shutdown");
        if (window.Intercom) {
            return window.Intercom("shutdown");
        }
        logger.log("shutdown intercom");
    },
};
export { IntercomProvider };
//# sourceMappingURL=intercom.provider.js.map